"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  workflowCommon: {
    flowManagement: '流程管理',
    instanceManagement: '实例管理',
    instanceDetail: '实例详情',
    flowInfo: '流程信息',
    search: '查询',
    reset: '重置',
    createTime: '创建时间'
  },
  workflowControl: {
    tab: {
      instanceSingleNumber: '实例单号',
      flowName: '流程名称',
      flowStatus: '流程状态',
      appName: '所属应用',
      creator: '发布人',
      createTime: '发布时间',
      beforeLink: '上个环节',
      beforeLinkTime: '上个环节耗时',
      currentLink: '当前环节',
      currentLinkTime: '当前环节耗时',
      operator: '操作人',
      flowType: '流程分类'
    },
    statusType: {
      running: '运行',
      hang: '挂起',
      finish: '完成',
      termination: '终止',
      exception: '异常'
    }
  }
};